<template>
  <div>
    <breadcrumbs :home="vessel.name + ': Move to site'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date" @change="refresh()"/>
              </v-col>
              <v-col class="text-caption ml-5 mt-3 grey--text">{{vesselContents}}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="6" lg="4">
                <v-autocomplete v-model="transaction.toSiteId" outlined dense label="Site"
                                :items="sites" item-text="name" item-value="id"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <v-text-field label="Location" v-model="transaction.location" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/>
              </v-col>
            </v-row>
            <v-row dense >
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense :rules="[fieldRules.maxLength(255)]" counter="255"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="transactionId && company.permissions.includes('inventory.write')">
            <v-switch v-if="transaction.date > company.excisePeriodEnd || edit" :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
            <div v-else class="grey--text">Cannot edit since excise filed to period end {{company.excisePeriodEnd | formatDate}}</div>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ExciseVesselTransferToSite',
  mixins: [confirmLeave],
  props: {
    vesselId: {type:String,required:false},
    transactionId: {type:String, required:false}
  },
  data () {
    return {
      vessel: {contents:{}},
      edit: false,
      transaction: {vesselId:this.vesselId,date:format(new Date(), 'yyyy-MM-dd HH:mm:ss'),comments:'',location:''},
      dirty: false,
      saving: false,
      loading: false,
      valid: true
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(!this.transactionId, {B263:true,B265:true,B266:true});
    },
    vesselContents() {
      return this.vessel.contents.volume ? this.vessel.contents.alcoholName : '';
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.loading = true;
    if (this.transactionId) {
      const results = await this.$apiCall(`query ExciseVesselTransferToSite($transactionId:ID!) {
                                                exciseVesselTransferSite(id:$transactionId) {
                                                  id,date,vesselId,toSiteId,location,comments
                                                }
                                              }`,
                                          {transactionId:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.exciseVesselTransferSite;
    }
    await this.refresh();
    if (!this.transactionId) {
      const uniqueSite = this.sites.find(s => s.id !== this.vessel.contents.siteId);
      this.transaction.toSiteId = uniqueSite ? uniqueSite.id : this.sites[0].id;
      this.edit = true;
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    async refresh() {
      const results = await this.$apiCall(`query ExciseVesselTransferToSite($id:ID!, $date:DateTime) {
                                                exciseVessel(id:$id) {
                                                  id,name,
                                                  contents(date:$date) {alcoholName,siteId,volume}
                                                }
                                              }`,
                                          {id:this.transaction.vesselId, date:this.transaction.date});
      if (!results.error)
        this.vessel = results.data.exciseVessel;
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const results = await this.$apiCall(`mutation ExciseVesselTransferToSite($input: ExciseVesselTransferSiteInput!) {
                                              exciseVesselTransferSiteCreate(input:$input) {id}
                                            }`, {input:this.transaction});
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} move to site transaction for ${this.vessel.name}`});
      }
    }
  }
}
</script>